var map = {
	"./beigne.png": "cAKA",
	"./full.png": "dz2R",
	"./off.png": "Ug5b",
	"./on.png": "tAiQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1zhD";


//////////////////
// WEBPACK FOOTER
// ./src/components/world/elements/img/cursor ^\.\/.*\.png$
// module id = 1zhD
// module chunks = 0